import type { SignalTimeframePeriod } from "app/pages/sales-intelligence/sub-modules/signals/models/miscellaneous/SignalTimeframe";
import signalsI18nKeys from "app/pages/sales-intelligence/sub-modules/signals/utils/i18n";
import type { Translatable } from "app/pages/sales-intelligence/types";

type TimeframeFilters = {
    readonly period?: SignalTimeframePeriod;
    readonly periodAmount?: number;
};

export function buildTimeframeTranslatable(
    period: SignalTimeframePeriod | undefined,
    periodAmount: number | undefined,
): Translatable | undefined {
    if (!period || !periodAmount) {
        return undefined;
    }

    return { key: `si.signals.timeframe.name.${period}-${periodAmount}` };
}

export function appendTimeframeSuffix(
    base: Readonly<Translatable>,
    filters: Readonly<TimeframeFilters>,
): Readonly<Translatable> {
    const timeframe = buildTimeframeTranslatable(filters.period, filters.periodAmount);

    return timeframe
        ? {
              key: signalsI18nKeys.name.withTimeframe,
              replacements: { name: base, timeframe },
          }
        : base;
}
